import React from "react";
import ReactDOMClient from "react-dom/client";
import "./assets/css/bootstrap.min.css";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "react-datepicker/dist/react-datepicker.css";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { Provider } from "react-redux";
import store from "./states/store";

import "./App.scss";
import "./custom.css";
import "./style.css";
import App from "./App.jsx";

import "react-toastify/dist/ReactToastify.css";

import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

// const stripePromise = loadStripe(
//   "pk_test_MBmgSxlJm4osKE52BTYcvXul0046kG0FiP"
//   // "pk_test_51NGLEZL24ZSbBCXMN1LMJWH0PxooFszcmkQ9ImeH9VOKvvlakPfN8rrbdaOGuW4e9hV4qej84Jgf8w5tSbOUDpHJ00mQ6cUP2y"
// );

const stripePromise = loadStripe(
  process.env.REACT_APP_ENV_MODE === "development"
    ? process.env.REACT_APP_STRIPE_TESTING_PUBLIC_KEY
    : process.env.REACT_APP_STRIPE_LIVE_PUBLIC_KEY
);

ReactDOMClient.createRoot(document.getElementById("root")).render(
  <Provider store={store}>
    <Elements stripe={stripePromise}>
      <App />
    </Elements>
  </Provider>
);
